<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import IdCell from './FilterTable/IdCell.svelte';
	import SocDemoCell from './FilterTable/SocDemoCell.svelte';
	import InterestsCell from './FilterTable/InterestsCell.svelte';
	import IncomeCell from './FilterTable/IncomeCell.svelte';
	import AdFormCell from './FilterTable/AdFormCell.svelte';
	import DeleteCell from './FilterTable/DeleteCell.svelte';
	import moment from 'moment';
	import type { Segment } from 'Segments';
	import SimpleTable from '../../SimpleTable.svelte';

	export let data = [];
	export let mixdata = [];
	let mixdataNames = [];

	$: {
		if (mixdata) {
			mixdata.forEach((segment) => {
				const combined = JSON.parse(segment.combined);
				combined.forEach((it: string) => {
					mixdataNames.push(it);
				});
			});
		}
	}
	$: console.log(mixdataNames);

	let dispatch = createEventDispatcher();
	function dispatchDeleted() {
		dispatch('dispatchRefresh');
	}

	const columns = [
		{
			key: 'id',
			title: 'ID',
			value: (v: Segment) => v.id,
			class: 'id',
			headerClass: 'id',
			renderComponent: {
				component: IdCell
			}
		},
		{
			key: 'name',
			title: 'Name',
			value: (v: Segment) => v.name,
			class: 'segment-name',
			headerClass: 'segment-name',
			searchValue: (v: Segment) => v.name,
			renderValue: (v: Segment) =>
				'<span style="max-width: 8vw; white-space: normal">' + v.name + '</span>',
			sortable: true
		},
		{
			key: 'socdemo',
			title: 'Soc Demo',
			value: (v: Segment) => v.socDemo.certainty,
			class: 'socdemo',
			headerClass: 'socdemo',
			renderComponent: {
				component: SocDemoCell
			}
		},
		{
			key: 'interests',
			title: 'Interests',
			value: (v: Segment) => v.interests,
			class: 'interests',
			headerClass: 'interests',
			renderComponent: {
				component: InterestsCell
			}
		},
		{
			key: 'income',
			title: 'Income',
			value: (v: Segment) => v.income,
			class: 'income',
			headerClass: 'income',
			renderComponent: {
				component: IncomeCell
			}
		},
		{
			key: 'created',
			title: 'Created at',
			value: (v: Segment) => v.firstRun,
			renderValue: (v: Segment) => moment(v.firstRun).format('MM/DD/YYYY'),
			class: 'first-run',
			headerClass: 'first-run',
			sortable: true
		},
		{
			key: 'adform',
			title: 'AdForm',
			value: (v: Segment) => v.id,
			class: 'adform',
			headerClass: 'adform',
			renderComponent: {
				component: AdFormCell,
				props: {
					mixArray: mixdataNames
				}
			}
		},
		{
			key: 'delete',
			title: 'Actions',
			value: (v: Segment) => v.id,
			class: 'delete',
			headerClass: 'delete',
			renderComponent: {
				component: DeleteCell,
				props: {
					mixArray: mixdataNames
				}
			}
		}
	];
</script>

<SimpleTable rows={data} {columns} sortBy="created" sortOrder={-1} on:refresh={dispatchDeleted} />
